export default __webpack_public_path__ + "static/bottom-2-f79f774fc0047649aec4363228bce274.png";